// @ts-nocheck
import React, { memo, useState } from 'react';
import { Handle, Position, NodeResizer } from 'reactflow';
import ReactMarkdown from 'react-markdown';
import type { DeepReviewNodeProps } from '../../../types/canvas';
import './DeepReviewNode.css';

interface TabItem {
  id: string;
  label: string;
  content: string;
}

/**
 * 深度审稿节点
 * 展示 Maker-Checker 模式生成的结构化分析结果
 */
const DeepReviewNode: React.FC<DeepReviewNodeProps> = ({ data, selected }) => {
  const { final_analysis, corrections, confidence } = data.content || {};
  const [activeTab, setActiveTab] = useState('problem');

  if (!final_analysis) {
    return (
      <div className={`deep-review-node ${selected ? 'selected' : ''}`}>
        <div className="node-header deep-review-header" style={{ background: '#f44336' }}>
          <span className="node-icon">⚠️</span>
          <span className="node-title">数据解析错误</span>
        </div>
        <div className="node-content tab-content">
          无法加载深度审稿数据
        </div>
        <Handle type="source" position={Position.Bottom} />
      </div>
    );
  }

  const tabs: TabItem[] = [
    { id: 'problem', label: '研究问题', content: final_analysis.research_problem },
    { id: 'method', label: '核心方法', content: final_analysis.core_method },
    { id: 'conclusion', label: '主要结论', content: final_analysis.main_conclusion },
    { id: 'innovation', label: '创新点', content: final_analysis.innovation },
    { id: 'limitation', label: '局限性', content: final_analysis.limitations || '未提及' },
  ];

  return (
    <div className={`deep-review-node ${selected ? 'selected' : ''}`}>
      <NodeResizer
        color="#673ab7"
        isVisible={selected}
        minWidth={400}
        minHeight={300}
      />
      <Handle type="target" position={Position.Top} className="node-handle" />

      <div className="node-header deep-review-header">
        <span className="node-icon">🧐</span>
        <span className="node-title">深度审稿</span>
        <span className={`confidence-badge ${confidence || 'medium'}`}>
          置信度: {confidence === 'high' ? '高' : confidence === 'low' ? '低' : '中'}
        </span>
      </div>

      <div className="tabs-header">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={activeTab === tab.id ? 'active' : ''}
            onClick={(e) => {
              e.stopPropagation();
              setActiveTab(tab.id);
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="node-content tab-content nodrag">
        <div className="markdown-body">
          <ReactMarkdown>
            {tabs.find(t => t.id === activeTab)?.content || ''}
          </ReactMarkdown>
        </div>

        {corrections && corrections.length > 0 && (
          <div className="corrections-panel">
            <strong>🤖 AI 修正记录 (Agent 2):</strong>
            <ul>
              {corrections.map((c, i) => <li key={i}>{typeof c === 'string' ? c : c.corrected}</li>)}
            </ul>
          </div>
        )}
      </div>

      <div className="node-footer">
        <span className="node-type-label">Deep Review (Maker-Checker)</span>
      </div>

      <Handle type="source" position={Position.Bottom} className="node-handle" />
    </div>
  );
};

export default memo(DeepReviewNode);
